function isFloat(num){
    return Number(num) === num && num % 1 !== 0;    
}

function isFloatString(value) {
    // Convert the value to a string
    const str = String(value).trim();

    // Define the regular expression for matching decimal numbers
    const regex = /^-?\d+(\.\d+)?([eE][-+]?\d+)?$/;

    // Test the string against the regular expression
    return regex.test(str) && !Number.isNaN(parseFloat(str)) && parseFloat(str) % 1 !== 0;
}



function chop_floating_point_values(array_of_objects){
    // this function takes an array of objects as input and chops the floating point values found in each object to 2 decimal places
    for (const obj of array_of_objects){
        for (const key of Object.keys(obj)){
            if ( typeof(obj[key]) == "number"){
                if (isFloat(obj[key])){
                    obj[key] = Number(obj[key].toFixed(0)) 
                }
            }
            else if (isFloatString(obj[key])){
                const chopped_value = parseFloat(obj[key]).toFixed(0)
                obj[key] = chopped_value
                console.log("obj[key]", obj[key], "chopped_value", chopped_value)
            }
            
        }       
    }
    return array_of_objects
}

export default chop_floating_point_values

// let data = [
//     {
//       _id: '662286a4ce99d45269e3b703',
//       product_name: 'DIGEST SYRUP 200ml',
//       sales: "1497.4299999999998",
//       quantity: 25
//     },
//     {
//       _id: '662286a4ce99d45269e3b705',
//       product_name: "HAEMOTEN TAB 10's",
//       sales: "14646.594",
//       quantity: 366
//     },
//     {
//       _id: '662286a4ce99d45269e3b6ff',
//       product_name: "NEURORICH TAB 10's",
//       sales: "114823.76799999994",
//       quantity: 2963
//     },
//     {
//       _id: '662286a4ce99d45269e3b6fd',
//       product_name: "CALFIT TAB 15's",
//       sales: "9702.844000000005",
//       quantity: 329
//     },
//     {
//       _id: '662286a4ce99d45269e3b701',
//       product_name: "PREFIX TAB 10's",
//       sales: "110723.68500000003",
//       quantity: 2761
//     }
//   ]

//   data = chop_floating_point_values(data)
//   console.table(data)
//   console.log(isFloatString("9702.844000000005"))
   